<template>
	<v-card dark>
		<v-card-title v-if="title" class="title" v-text="title" />
		<v-card-subtitle v-if="subtitle" class="subtitle" v-text="subtitle" />
		<v-simple-table class="info-table">
			<slot />
		</v-simple-table>
	</v-card>
</template>

<style lang="scss" scoped>
.title {
	color: var(--v-accent-base);
}

.subtitle {
	text-align: left;
}

.info-table {
	::v-deep tr > td {
		text-align: left;

		&.label {
			color: var(--v-accent-base);
			text-transform: uppercase;
			font-weight: bold;
		}

		&.value {
			font-size: 80%;
		}
	}
}
</style>

<script>
export default {
	props: ["title", "subtitle"],
};
</script>
